import React from 'react';
import PropTypes from 'prop-types';
import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { Loader } from '@statsbomb/kitbag-components';
import { Navigate } from 'react-router-dom';

export const GroupOnlyRoute = ({ group, children }) => {
  const { user, isLoading } = useKitbagAuth();

  // Show a loader while auth resolves (mirrors ProtectedRoute) rather than
  // flashing a blank screen on first render.
  if (isLoading) {
    return <Loader />;
  }

  // If a group is required, check that the user's accountID claim matches it.
  const accountId = user?.['https://statsbomb.com/accountID'];
  const hasAccess = !group || group === accountId;
  if (hasAccess) {
    return children;
  }
  return <Navigate to="/" replace />;
};

GroupOnlyRoute.propTypes = {
  group: PropTypes.string,
  children: PropTypes.element,
};

GroupOnlyRoute.defaultProps = {
  group: '',
  children: null,
};

export default { GroupOnlyRoute };
